import {Component, computed, inject} from '@angular/core';
import {TeamStore} from "../store/team-store";

@Component({
  selector: 'app-team-circle',
  templateUrl: './team-circle.component.html',
  styleUrls: ['./team-circle.component.scss'],
  imports: [],
  standalone: true,
  providers: [TeamStore]
})
export class TeamCircleComponent {

  readonly #store: any = inject(TeamStore);
  protected readonly error = this.#store.error;

  protected readonly team = this.#store.team;
  activeMember: any = null;

  layers = computed(() => {
    const team = this.team() || [];

    return [
      team.slice(0, 2),  // inner circle
      team.slice(2, 6),  // middle circle
      team.slice(6, 13), // outer circle
    ];
  });
}
